import { render, staticRenderFns } from "./customMessage.vue?vue&type=template&id=530c937a&"
import script from "./customMessage.vue?vue&type=script&lang=js&"
export * from "./customMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports